<template>
  <div>
    <jet-dialog-modal :show="openModal" @close="closeModal">
      <template #title> เพิ่มโดเมน </template>

      <template #content>
        <div class="mt-4">
          <jet-label for="domain_name" value="ชื่อโดเมน*" />
          <jet-input
            type="text"
            class="mt-1 block w-3/4"
            placeholder="https://www.example.com or http://www.example.com"
            ref="domain_name"
            v-model="form.domain_name"
          />

          <jet-input-error :message="form.errors.domain_name" class="mt-2" />
        </div>
      </template>

      <template #footer>
        <jet-secondary-button @click="closeModal">
          ยกเลิก
        </jet-secondary-button>

        <jet-button
          class="ml-3"
          @click="createProject"
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
        >
          เพิ่มโดเมน
        </jet-button>
      </template>
    </jet-dialog-modal>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import JetActionSection from "@/Jetstream/ActionSection.vue";
import JetDialogModal from "@/Jetstream/DialogModal.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetInput from "@/Jetstream/Input.vue";
import JetLabel from "@/Jetstream/Label.vue";
import JetInputError from "@/Jetstream/InputError.vue";
import JetSecondaryButton from "@/Jetstream/SecondaryButton.vue";

export default defineComponent({
  props: ["openModal"],

  components: {
    JetActionSection,
    JetButton,
    JetDialogModal,
    JetInput,
    JetInputError,
    JetSecondaryButton,
    JetLabel,
  },

  data() {
    return {
      form: this.$inertia.form({
        domain_name: null,
      }),
    };
  },

  methods: {
    createProject() {
      this.form.post(route("projects.store"), {
        preserveScroll: false,
        onSuccess: () => this.closeModal(),
        onError: () => this.$refs.domain_name.focus(),
        onFinish: () => this.form.reset(),
      });
    },

    closeModal() {
      this.form.reset();
      this.$emit("close-modal");
    //   this.$emit("op-script-modal");
    },
  },

  watch: {
    openModal(value) {
      if (value) //open
        setTimeout(() => this.$refs.domain_name.focus(), 250);
    }
  },
});
</script>
